import React from 'react';
import DetectionGroupContext from '.';
import useProjectIdContext from '../../../../Contexts/ProjectContexts/ProjectIdContext/useProjectIdContext';
import useContentMaps from '../../../../LiveContext/Hooks/useSession/useContentMaps';
import { LatestDetection } from '../../../../LiveContext/SessionContext/SessionDetectionContextProvider/useSessionDetectionContext';
import useSessionContext from '../../../../LiveContext/SessionContextProvider/useSessionContext';
import useDetectionVisibility from './Hooks/useDetectionVisibility';

interface DetectionBadgeContextProviderProps {
  children: React.ReactNode;
  tab: { index: number, updatedAt: number };
}

export default function DetectionGroupContextProvider(props: DetectionBadgeContextProviderProps) {
  const { children, tab } = props;
  const { latestDetection } = useSessionContext();
  const { projectId } = useProjectIdContext();
  const { cardTitleMap, commandTitleMap } = useContentMaps(projectId);
  const [detections, setDetections] = React.useState<(LatestDetection & { cardTitle: string, commandTitle: string })[]>([]);
  React.useEffect(() => {
    if (latestDetection) {
      const cardTitle = cardTitleMap.get(latestDetection.cardId) ?? '';
      const commandTitle = commandTitleMap.get(latestDetection.commandId) ?? '';
      const latestDetectionWithTitles = { ...latestDetection, cardTitle, commandTitle };
      setDetections((prev) => [...prev, latestDetectionWithTitles]);
    } else {
      setDetections([]);
    }
  }, [latestDetection]);

  const value = useDetectionVisibility(detections, tab, latestDetection);

  return (
    <DetectionGroupContext.Provider value={value}>
      {children}
    </DetectionGroupContext.Provider>
  );
}
